export interface UploadRequest {
    fileName: string;
    fileParameterName: string;
    headers: UploadRequestParameter[];
    httpMethod: UploadRequestHttpMethod;
    kind: UploadRequestKind;
    parameters: UploadRequestParameter[];
    provider: string;
    url: string;
}

export enum UploadRequestHttpMethod {
    Post = "POST",
    Put = "PUT",
}

export enum UploadRequestKind {
    MultipartForm = "MULTIPART_FORM",
    RequestBody = "REQUEST_BODY",
}

export interface UploadRequestParameter {
    key: string;
    value: string;
}
